// src/com/download_info/DownloadPopup.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, CircularProgress } from '@mui/material';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';


const InfoTitle = styled(DialogTitle)({
    backgroundColor: '#007', // AppPalette.HeaderBackground,
    color: 'white',
    minWidth: 300,
});

const RecordBox = styled(Box)({
    display: 'flex', alignItems: 'center', padding: 5, marginTop: 10,
});

const TitleBox = styled(Box)({
    fontSize: '0.9rem', flexGrow: 1, // [이트레이스 사용매뉴얼]
});

const TypeBox = styled(Box)({
    fontSize: '0.8rem', color: '#555', marginLeft: 10, minWidth: 100, // [매뉴얼]
    textAlign: 'center',
});

const DateBox = styled(Box)({
    fontSize: '0.8rem', color: '#555', marginLeft: 10
});

/*
{
    "msg":"ok",
    "list":[
        {"type":"매뉴얼", "title":"이트레이스 사용매뉴얼", "url":"/files/pub/abc.txt", "date":"2015-07-22"},
        {"type":"신청서", "title":"구비서류_은행(자동이체)신청서", "url":"/files/pub/xyz.txt", "date":"2019-08-08"}
    ]
}
*/

export default function DownloadPopup({
    open,
    onClose,
}) {
    const [fileList, setFileList] = useState([]);
    // 로딩 및 에러 상태 관리를 위한 state
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // use fetch to get json file (static)

    // 컴포넌트가 처음 렌더링될 때 데이터를 불러옵니다.
    useEffect(() => {
        if(open) {
            fetch('/files/cvoFiles.json') // public 폴더의 파일은 루트 경로로 접근
                .then(response => {
                    if (!response.ok) {
                        throw new Error('데이터를 불러오는 데 실패했습니다.');
                    }
                    return response.json();
                })
                .then(data => {
                    // 데이터 형식이 올바른지 확인 후 state 업데이트
                    if (data.msg === 'ok' && Array.isArray(data.list)) {
                        setFileList(data.list);
                    } else {
                        throw new Error('데이터 형식이 올바르지 않습니다.');
                    }
                })
                .catch(err => {
                    console.error("파일 목록 fetch 오류:", err);
                    setError(err.message);
                })
                .finally(() => {
                    setLoading(false); // 로딩 종료
                });
        }
        else {
            setFileList([]);
        }
    }, [open]);

    const renderList = () => {
        return(
            <Box>
                {fileList.map((file, index) => {
                    const idxLastSlash = file.url.lastIndexOf('/');
                    const path = file.url.substring(0, idxLastSlash + 1);
                    const filePart = file.url.substring(idxLastSlash + 1);
                    const url = path + encodeURIComponent(filePart);
                    return(
                        <RecordBox key={index}>
                            <DownloadForOfflineIcon fontSize="small" style={{ marginRight: 5 }} />
                            <TitleBox>
                                <a href={url} target="_blank" rel="noopener noreferrer" download>
                                    {file.title}
                                </a>
                            </TitleBox>
                            <TypeBox>{file.type}</TypeBox>
                            <DateBox>{file.date}</DateBox>
                        </RecordBox>)
                    ;
                })}
            </Box>
        );
    };
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md">
            <InfoTitle>
                파일 다운로드
            </InfoTitle>
            <DialogContent>
                {
                    loading
                    ?
                    <CircularProgress size={24} />
                    :
                    error
                    ?
                    <Box style={{margin: 30, color: '#f44336'}}>
                        {error}
                    </Box>
                    :
                    renderList()
                }
            </DialogContent>
        </Dialog>
    );
}

/*
처음에 복사, 붙여넣기는 vscode에서 해당 파일을 우클릭하여 상대경로 복사한 후 붙여넣기하고, 편집했어. 그리고는 오류가 났지.

이렇게 하니 해결됐어. 맥북 터미널에서 그 디렉토리를 ls 해서 파일이름들을 출력한 후 터미널에 출력된 파일이름들을 복사한 후 붙여넣기 했어. 
눈으로 보는 모양은 똑같지만 어쨌든 해 봤지. 
그리고 다시 서버로 올린 후 테스트 했더니, 다운로드가 잘 돼! 이런 희한한...

=====================

네, 바로 그겁니다! 그 두 가지 방법의 차이가 이번 문제의 모든 것을 설명해주는 완벽한 마지막 조각입니다. "눈으로 보는 모양은 똑같지만" 결과는 달랐던 이유는 **VS Code는 표준을, 터미널은 OS의 원본을 보여주었기 때문**입니다.

정말 희한하고 처음 겪는 일이 맞습니다. 아주 깊은 수준의 운영체제(OS)와 인코딩 문제였기 때문입니다.

---

### ## 왜 그런 차이가 발생했을까요?

#### 1. VS Code의 '상대 경로 복사'

VS Code는 웹 기술(Electron)을 기반으로 만들어진 현대적인 에디터입니다. 이 때문에 여러 운영체제에서 동일하게 작동하도록 **웹 표준(NFC - 조합형)**을 매우 잘 따릅니다.

-   **동작 방식:** 사용자가 '상대 경로 복사'를 클릭했을 때, VS Code는 macOS의 파일 시스템에 자소분리(NFD) 형식으로 저장된 파일명을 읽은 뒤, **"웹에서 사용하기 편하게끔" 표준인 NFC(조합형) 형식으로 변환하여 클립보드에 넣어줍니다.**
-   **결과:** JSON 파일에는 **NFC(조합형)** 텍스트가 붙여넣기 되었습니다. 하지만 서버에는 자소분리(NFD) 형태의 파일이 있었으므로, 당연히 파일을 찾지 못하고 오류가 발생했습니다.

#### 2. 터미널 `ls` 명령어

터미널의 `ls` 명령어는 꾸밈이나 변환 없이, **파일 시스템에 저장된 원본(raw) 파일명 바이트를 그대로** 읽어서 화면에 보여줍니다.

-   **동작 방식:** MacBook의 터미널은 파일 시스템의 **NFD(자소분리)** 파일명을 그대로 출력했습니다.
-   **결과:** JSON 파일에는 **NFD(자소분리)** 텍스트가 붙여넣기 되었습니다. 서버에 있는 파일 역시 NFD 형식이므로, 두 문자열이 바이트 단위까지 완벽하게 일치하여 마침내 파일을 찾고 다운로드가 성공한 것입니다.



---

### ## 최종 결론

이 모든 여정은 결국 **"서버에 저장된 파일의 한글 인코딩 방식(NFD)과 JSON 데이터의 한글 인코딩 방식이 일치하지 않았던 문제"**였습니다. 그리고 그 불일치는 데이터를 복사하는 방식의 미세한 차이에서 비롯되었습니다.

-   **실패의 원인:** VS Code가 친절하게 웹 표준(NFC)으로 변환해 준 것이 오히려 독이 되었습니다.
-   **성공의 열쇠:** 터미널이 아무런 변환 없이 날것 그대로의 파일명(NFD)을 보여준 덕분에 데이터가 일치하게 되었습니다.


*/

